<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">내 정보 수정</div>
			<table class="table type-input">
				<colgroup>
					<col width="20%" />
					<col width="80%" />
				</colgroup>
				<tr>
					<th>아이디</th>
					<td>{{ form.mem_id }}</td>
				</tr>
				<tr>
					<th>이름</th>
					<td><input type="text" class="form-control" v-model="form.mem_name" placeholder="이름" /></td>
				</tr>
				<tr>
					<th>휴대폰</th>
					<td><input type="text" class="form-control" v-model="form.mem_mobile" placeholder="010-0000-0000" /></td>
				</tr>
				<tr>
					<th>전화번호</th>
					<td><input type="text" class="form-control" v-model="form.mem_phone" placeholder="02-0000-0000" /></td>
				</tr>
				<tr>
					<th>팩스번호</th>
					<td><input type="text" class="form-control" v-model="form.mem_fax" placeholder="02-0000-0000" /></td>
				</tr>
				<tr>
					<th>이메일</th>
					<td><input type="text" class="form-control" v-model="form.mem_email" placeholder="example@domain.com" /></td>
				</tr>
			</table>
			<div class="btn-wrap">
				<button type="button" class="btn btn-primary" @click="btnSave" :disabled="saving">저장</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MyProfile',
	data() {
		return {
			// mem_id 는 표시 전용(서버는 토큰 mem_uid 로만 본인 행 갱신 — 폼 값과 무관).
			form: { mem_id: '', mem_name: '', mem_mobile: '', mem_phone: '', mem_fax: '', mem_email: '' },
			saving: false,
		};
	},
	created() {
		this.load();
	},
	methods: {
		load() {
			this.$apiGET('/admin/api/user/self').then(re => {
				if (!re) return;
				this.form.mem_id = re.mem_id || '';
				this.form.mem_name = re.mem_name || '';
				this.form.mem_mobile = re.mem_mobile || '';
				this.form.mem_phone = re.mem_phone || '';
				this.form.mem_fax = re.mem_fax || '';
				this.form.mem_email = re.mem_email || '';
			});
		},
		btnSave() {
			if (!this.form.mem_name || !this.form.mem_name.trim()) {
				alert('이름을 입력해주세요.');
				return;
			}
			if (this.saving) return;
			this.saving = true;
			this.$apiPOST('/admin/api/user/self/update', {
				mem_name: this.form.mem_name,
				mem_mobile: this.form.mem_mobile,
				mem_phone: this.form.mem_phone,
				mem_fax: this.form.mem_fax,
				mem_email: this.form.mem_email,
			}).then(re => {
				this.saving = false;
				if (re !== true) return; // 실패 시 seon.js apiPOST 가 이미 사유 alert
				alert('저장되었습니다.');
				// 헤더 등에서 쓰는 userInfo(mem_name 등) 즉시 갱신.
				this.$apiGET('/admin/api/user/info').then(info => {
					if (info) this.$store.dispatch('callSetUserInfo', info);
				});
			});
		},
	},
};
</script>
